import { from, MonoTypeOperatorFunction, Observable, ObservableInput } from 'rxjs';
import { connect, map, switchMap } from 'rxjs/operators';

export function switchTap<T>(next: (value: T) => ObservableInput<any>): MonoTypeOperatorFunction<T> {
  return (source$: Observable<T>) =>
    source$.pipe(connect((published: Observable<T>) => published.pipe(switchMap((value: T) => from(next(value)).pipe(map(() => value))))));
}
